import React, {createContext, useReducer} from 'react'

export const SET_SHIFT_LIST = 'SET_SHIFT_LIST'
export const SELECT_SHIFT = 'SELECT_SHIFT'
export const SET_SHOW_SHIFT_POPUP = 'SET_SHOW_SHIFT_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_SHIFT_LIST:
      return { ...data, shift_list: payload.data }
    case SELECT_SHIFT:
      return {
        ...data,
        selected_shift: payload.data.selected_shift,
        show_shift_popup: payload.data.show_shift_popup,
      }
    case SET_SHOW_SHIFT_POPUP:
      return {
        ...data,
        show_shift_popup: payload.data,
        selected_shift: payload.data ? data.selected_shift : {},
      }
    default:
      return data
  }
}

const initialState = {
  shift_list: [],
  selected_shift: {},
  show_shift_popup: false,
}

const ShiftStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ShiftContext.Provider value={[state, dispatch]}>
      {children}
    </ShiftContext.Provider>
  )
}

export const ShiftContext = createContext(initialState)
export default ShiftStore
